import { render, staticRenderFns } from "./AppBarUserMenu.vue?vue&type=template&id=1f049b60&"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=js&"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppBarUserMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports